module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "yellowcard.64c3d720.png";